﻿import { OutputField } from "@models/configurators/output-fields/output-field";
import { KbObjectManager } from "@models/configurators/kb-object-manager";
import { eOutputFieldType } from "@models/enums";
import { ICadDimensionField } from "@models/entity-models";
import { KboOutputField } from "@models/configurators/configurator-di";
import { CToken } from "@models/configurators/ctoken";

@KboOutputField(CToken.CadDimensionField, eOutputFieldType.cadDimension)
export class CadDimensionField extends OutputField implements ICadDimensionField {
    constructor(kom: KbObjectManager) {
        super(kom);
    }

    public markedForDrawing: boolean;
    public value: number;
}
